exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.smallLogo[data-v-abc82e8c] {\n  width: 31px;\n  position: absolute;\n  top: 20px;\n  left: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-abc82e8c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/auth/sidebars/LoginSidebar.vue
// module id = 1217
// module chunks = 0